var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglassSimpleHigh = function SvgIconHourglassSimpleHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.558 2.75h12.884a1.75 1.75 0 0 1 1.229 2.994l-2.456 2.455-.016.016L13.414 12l6.257 6.256a1.75 1.75 0 0 1-1.229 2.994H5.558a1.75 1.75 0 0 1-1.229-2.994L10.586 12 4.329 5.744A1.75 1.75 0 0 1 5.558 2.75M16.086 6.5l1.75-1.75H6.164l1.75 1.75zm-6.172 2h4.172L12 10.586zm7.922 10.75L12 13.414 6.164 19.25z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglassSimpleHigh;